import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import {
  createCategory,
} from '../../../../../../../../crud/menu_api/categories';
import { addMenuCategoryToMenu } from '../../../../../../../../crud/menu_api/menus';
import { getAllMenuCategoryTypes } from '../../../../../../../../crud/menu_api/menu_category_types';
import {  ParentsCategorys, RawMenuCategoryS } from '../../../../types';
import './CreateCategory.scss';
import { Dropdown } from 'react-bootstrap';
import {
  getMenusOptions,
  getWorkstationsOptions,
  WorkstationOption,
} from '../../../utils/utils';


interface CreateCategoryProps {
  showCreateModal: boolean;
  setShowCreateModal: (show: boolean) => void;
  currentData: any[];
  setCurrentData: (data: any[]) => void;
  originalCategories: ParentsCategorys[];
  setOriginalCategories: (data: ParentsCategorys[]) => void;
  setCategories: (data: ParentsCategorys[]) => void;
}

const CreateCategory: React.FC<CreateCategoryProps> = ({
  showCreateModal,
  setShowCreateModal,
  currentData,
  setCurrentData,
  originalCategories,
  setOriginalCategories,
  setCategories,
}) => {
  // Estados para el formulario
  const [workstations, setWorkstations] = useState<WorkstationOption[]>([]);
  const [isMain, setIsMain] = useState<boolean>(true);
  const [workstationId, setWorkstationId] = useState<number>(0);
  const [categoryName, setCategoryName] = useState<string>('');
  const [menuCategoryTypes, setMenuCategoryTypes] = useState<any[]>([]);
  const [menuCategoryType, setMenuCategoryType] = useState<{ id: number | null, name: string }>({ id: null, name: '' });
  const [isLoading, setIsLoading] = useState(false);

  // Dropdowns opcionales
  const [menus, setMenus] = useState<any[]>([]);
  const [selectedMenuId, setSelectedMenuId] = useState<number>(0);

  // Check if category name already exists
  const categoryNameExists = currentData.some(
    (category: any) => category.category_name.toLowerCase() === categoryName.toLowerCase()
  );

  // Form validation
  const isFormValid = categoryName.trim() !== '' && workstationId !== 0 && selectedMenuId !== 0 && !categoryNameExists;


  useEffect(() => {
    getWorkstationsOptions().then(resp => {
      if (resp) setWorkstations(resp);
    });
    getMenusOptions().then(resp => {
      if (resp && resp.length > 0) {
        setMenus(resp);
      }
    });
    getAllMenuCategoryTypes()
      .then((response: any) => {
        if (response && response.data) {
          setMenuCategoryTypes(response.data);
        } else {
          setMenuCategoryTypes([]);
        }
      })
      .catch(() => setMenuCategoryTypes([]));;
  }, []);

  // Ensure first menu is selected by default after menus are loaded
  useEffect(() => {
    if (showCreateModal && menus.length > 0) {
      const firstValid = menus.find((menu: any) => menu.id !== 0);
      if (firstValid && selectedMenuId !== firstValid.id) {
        setSelectedMenuId(firstValid.id);
      }
    }
  }, [menus, showCreateModal]);

  // Reset selectedMenuId when modal is closed
  useEffect(() => {
    if (!showCreateModal) {
      setSelectedMenuId(0);
    }
  }, [showCreateModal]);

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form) {
      console.error('Form not found.');
      return;
    }
    setIsLoading(true);
    const userContext = localStorage.getItem('user');
    const localId = userContext ? JSON.parse(userContext).local_id : 0;
    
    // Si se selecciona "0", se interpreta que no hay selección
    const w_id = workstationId;
    const parentCategory = form.category_id
      ? (form.category_id.value === "0" || form.category_id.value === "" ? null : form.category_id.value)
      : null;

    // Obtenemos el nombre de la estación seleccionada
    const workstationOption = workstations.find(ws => ws.id === Number(w_id));
    const workstation_name = workstationOption ? workstationOption.name : "Ninguno";

    // Construir el payload con las propiedades requeridas y adicionales
    const create_category: RawMenuCategoryS = {
      category_id: 0,
      category_name: categoryName,
      is_main: isMain,
      workstation_id: w_id,
      local_id: localId,
      isParent: false,
      isEmpty: true,
      state: true,
      menu_category_type_id: menuCategoryType.id,
      menu_category_type_name: menuCategoryType.name,
      ...(parentCategory && { parent_category_id: parentCategory }),
      workstation_name: workstation_name,
      menus: []
    };

    createCategory(create_category)
      .then(response => {
        create_category.category_id = (response as any).data.category_id;
        toast.success('Categoría creada con éxito!');

        if (create_category.parent_category_id) {
          setShowCreateModal(false);

          let updatedData = currentData.filter((c: any) => c.category_id !== create_category.category_id);
          updatedData = [create_category, ...updatedData];

          setCurrentData(updatedData);
          setCategories(updatedData);
          setOriginalCategories(updatedData);
        } else {
          setShowCreateModal(false);

          if (selectedMenuId !== 0) {
            addMenuCategoryToMenu(Number(selectedMenuId), Number(create_category.category_id))
              .then(() => {
                toast.success('Categoría agregada al menú con éxito!');

                const selectedMenu = menus.find(menu => menu.id === selectedMenuId);
                if (selectedMenu) {
                  create_category.menus = [{ menu_id: selectedMenu.id, menu_name: selectedMenu.name }];
                }

                let updatedData = currentData.filter((c: any) => c.category_id !== create_category.category_id);
                updatedData = [create_category, ...updatedData];

                setCurrentData(updatedData);
                setCategories(updatedData);
                setOriginalCategories(updatedData);
              })
              .catch(error => {
                console.error('Error al agregar la categoría al menú:', error);
                toast.error('Error al agregar la categoría al menú');
              });
          } else {
            let updatedData = currentData.filter((c: any) => c.category_id !== create_category.category_id);
            updatedData = [create_category, ...updatedData];

            setCurrentData(updatedData);
            setCategories(updatedData);
            setOriginalCategories(updatedData);
          }
        }
      })
      .catch((error: any) => {
        // --- LÓGICA DE ERRORES ACTUALIZADA (Todo en Rojo) ---
        console.log("🔍 Error Backend:", error.response); 

        const status = error.response?.status;
        const data = error.response?.data;

        // Caso 1: Error específico en el campo del nombre
        const fieldError = data?.name || data?.category_name;
        if (fieldError) {
            const msg = Array.isArray(fieldError) ? fieldError[0] : fieldError;
            toast.error(` ${msg}`); // CAMBIADO A ERROR (ROJO)
            return;
        }

        // Caso 2: Mensaje general (detail, message, error)
        const generalMsg = data?.message || data?.detail || data?.error;
        if (generalMsg) {
             if (typeof generalMsg === 'string' && 
                (generalMsg.toLowerCase().includes('exist') || generalMsg.toLowerCase().includes('duplic'))) {
                 toast.error('Ya existe una categoría con ese nombre.'); // CAMBIADO A ERROR (ROJO)
             } else {
                 toast.error(`Error: ${generalMsg}`);
             }
             return;
        }

        // Caso 3: Error 400 sin detalle claro
        if (status === 400) {
            toast.error('No se pudo crear. Es posible que el nombre ya exista.'); // CAMBIADO A ERROR (ROJO)
            return;
        }

        // Fallback genérico
        toast.error('Ocurrió un error inesperado al crear la categoría.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const WorkstationsDropdown = (
    <Form.Group className="mp-formgroup horizontal">
      <Form.Label>Estación de trabajo</Form.Label>
      <Dropdown
        onSelect={(eventKey: string | null) =>
          setWorkstationId(eventKey ? Number(eventKey) : 0)
        }
      >
        <Dropdown.Toggle
          variant="light"
          id="dropdown-workstation"
          className="dropdown-toggle"
        >
          {workstationId
            ? workstations.find(w => w.id === workstationId)?.name
            : 'Seleccionar estación'}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="0">
            -- Ninguna --
          </Dropdown.Item>
          {workstations.map(ws => (
            <Dropdown.Item key={ws.id} eventKey={ws.id.toString()}>
              {ws.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );

  const MenuCategoryTypesDropdown = (
    <Form.Group className="mp-formgroup horizontal">
      <Form.Label>Tipo de categoría</Form.Label>
      <Dropdown
        onSelect={(eventKey: string | null) => {
          if (!eventKey) return;
          const selectedId = Number(eventKey);
          const selectedType = menuCategoryTypes.find(type => type.menu_category_type_id === selectedId);
          if (selectedType) {
            setMenuCategoryType({ id: selectedId, name: selectedType.name });
          }
        }}
      >
        <Dropdown.Toggle
          variant="light"
          id="dropdown-category-type"
          className="dropdown-toggle"
        >
          {menuCategoryType.id
            ? menuCategoryTypes.find(type => type.menu_category_type_id === menuCategoryType.id)?.name
            : 'Seleccionar tipo'}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="0">-- Seleccionar tipo --</Dropdown.Item>
          {menuCategoryTypes.map((type: any) => (
            <Dropdown.Item
              key={type.menu_category_type_id}
              eventKey={type.menu_category_type_id.toString()}
            >
              {type.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );

  // Filter out 'Ninguno' and ensure correct type
  const validMenus: { id: number; name: string }[] = Array.isArray(menus)
    ? menus.filter((menu: any) => menu.id !== 0 && typeof menu.id === 'number' && typeof menu.name === 'string')
    : [];

  const MenuSelection = (
    <Form.Group className="mp-formgroup vertical">
      <Form.Label>Agregar a Menú</Form.Label>
      <div className="menu-selection-container">
        {validMenus.length === 0 ? (
          <div className="no-menus-message">
            <span>No hay menús disponibles</span>
          </div>
        ) : (
          validMenus.map((menu: { id: number; name: string }, idx: number) => {
            const isSelected = selectedMenuId === menu.id || (selectedMenuId === 0 && idx === 0);
            return (
              <div
                key={menu.id}
                className={`menu-option${isSelected ? ' selected' : ''}`}
                onClick={() => setSelectedMenuId(menu.id)}
              >
                <span className="menu-name">{menu.name}</span>
                <div className="menu-indicator"></div>
              </div>
            );
          })
        )}
      </div>
    </Form.Group>
  );


  return (
    <Modal 
      show={showCreateModal} 
      onHide={() => setShowCreateModal(false)} 
      centered
      className="create-category-modal"
    >
      <Form onSubmit={handleFormSubmit}>
        <Modal.Header>
          <div className="form-modal-title-container">
            <Modal.Title className="form-modal-title">
              Crear categoría
            </Modal.Title>
          </div>
          <Button 
            variant="none" 
            className="modal-close-button" 
            onClick={() => setShowCreateModal(false)}
          >
            <X size={24} />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="form-container">
            <Form.Group controlId="category_name" className="mp-formgroup horizontal">
              <Form.Label>Nombre</Form.Label>
              <Form.Control 
                type="text" 
                name="category_name" 
                placeholder="Ingresa el nombre de la categoría" 
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                required 
              />
            </Form.Group>

            {categoryNameExists && (
              <div className="duplicate-category-banner">
                <Form.Text className="duplicate-banner-text">
                  <strong>⚠️ Esta categoría ya existe.</strong> Por favor, ingresa un nombre diferente para crear una nueva categoría.
                </Form.Text>
              </div>
            )}

            {WorkstationsDropdown}

            {/* Visibility Options */}
            <Form.Group className="mp-formgroup horizontal">
              <div>
                <Form.Label>Visibilidad del menú</Form.Label>
                <Form.Text className="text-muted">
                  Elige si la categoría será visible para los clientes
                </Form.Text>
              </div>
              <div className="visibility-options">
                <div 
                  className={`visibility-option visible ${isMain ? 'selected' : ''}`}
                  onClick={() => setIsMain(true)}
                >
                  <FaEye className="option-icon" />
                  <span className="option-text">Visible</span>
                </div>
                <div 
                  className={`visibility-option hidden ${!isMain ? 'selected' : ''}`}
                  onClick={() => setIsMain(false)}
                >
                  <FaEyeSlash className="option-icon" />
                  <span className="option-text">Oculta</span>
                </div>
              </div>
            </Form.Group>
            {!isMain && (
              <div className="oculta-description-banner">
                <Form.Text className="oculta-description-text">
                  Al seleccionar <strong>Oculta</strong>, la categoría no aparecerá en los menús públicos. Sirve para organizar productos privadamente, ideal para agregados y opciones extras de los platos que no se venden individualmente.
                </Form.Text>
              </div>
            )}

            {MenuCategoryTypesDropdown}
            {MenuSelection}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="form-modal-footer-custom">
            <Button 
              className="form-button-cancel" 
              variant="secondary" 
              onClick={() => setShowCreateModal(false)}
              disabled={isLoading}
            >
              Cancelar
            </Button>
            <Button 
              className="form-button-create" 
              variant="primary" 
              type="submit"
              disabled={isLoading || !isFormValid}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Creando...
                </>
              ) : (
                'Crear'
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateCategory;